<template>
  <section class="bx-search__header bx-typo--search-header bx-filters">
    <div>
      <strong ref="directFilterNow"
              @click="updateAirtimeFilter('now')">
        Jetzt
      </strong>
      <strong ref="directFilter2015"
              @click="updateAirtimeFilter(getAirTimeForSelectedDay('20:15'))">
        20:15
      </strong>
      <strong ref="directFilter2200"
              @click="updateAirtimeFilter(getAirTimeForSelectedDay('22:00'))">
        22:00
      </strong>
    </div>

    <div tabindex="0"
         role="button"
         :aria-label="ariaLabelFilters"
         :aria-expanded="filtersOpen"
         class="bx-filtertoggle"
         @click.prevent="toggleFilters"
         @keyup.enter="toggleFilters">
      <Icon name="filters"
            :class="filtersOpen ? 'icon--active' : 'icon--inactive'" />
      <div ref="filterCount"
           class="bx-filter__count bx-typo--14px" />
      <span>
        Filter
        <span> {{ labelFilterToggle }}</span>
      </span>
    </div>
  </section>
</template>

<script>
import { format, parse } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'

import Icon from '../../../../../components/shared/Icon.vue'
import epgAirTimeHelper from '../../mixins/epg-air-time-helper'

export default {
  components: { Icon },
  mixins: [epgAirTimeHelper],
  props: {
    filtersOpen: {
      type: Boolean,
      required: true
    },
    selectedFilters: {
      type: Object,
      required: true
    }
  },
  emits: ['toggle-filters', 'update:air-time-filter'],
  computed: {
    labelFilterToggle () {
      return this.filtersOpen ? 'auswählen' : 'anzeigen'
    },
    ariaLabelFilters () {
      return this.filtersOpen ? 'Filter schliessen' : 'Filter öffnen'
    },
    // Count the number of selected filters
    // categoryIds is an array, so we need to check its length
    // packageName is a string, so we check if it's not 'all'
    // isDailyTip is a boolean, so we check if it's true
    // airTime is a string, so we check if it's not empty
    // We return the total count of selected filters
    filterCount () {
      return Object.entries(this.selectedFilters).reduce((count, [key, value]) => {
        if (key === 'categoryIds' && Array.isArray(value)) {
          return count + value.length
        } else if ((key === 'packageName' && value !== 'all') ||
          (key === 'isDailyTip' && value) ||
          (key === 'airTime')) {
          return count + 1
        }
        return count
      }, 0)
    }
  },
  watch: {
    // Watch for changes in selectedFilters to update the filter count
    selectedFilters: {
      handler () {
        this.setFilterCount()
        this.setDirectFilterActive()
      },
      deep: true
    }
  },
  mounted () {
    this.setFilterCount()
    this.setDirectFilterActive()
  },
  methods: {
    setFilterCount () {
      // This method is called to set the filter count
      // It can be used to update the UI or perform other actions
      this.$refs.filterCount.textContent = this.filterCount.toString()
    },
    setDirectFilterActive () {
      // reset all direct filter active classes
      this.$refs.directFilterNow.classList.remove('bx-js-active')
      this.$refs.directFilter2015.classList.remove('bx-js-active')
      this.$refs.directFilter2200.classList.remove('bx-js-active')

      // set the active class based on the selected filters
      if (this.selectedFilters?.airTimeOptions === 'now') {
        this.$refs.directFilterNow.classList.add('bx-js-active')
      } else if (this.selectedFilters?.airTime === this.getAirTimeForSelectedDay('20:15')) {
        this.$refs.directFilter2015.classList.add('bx-js-active')
      } else if (this.selectedFilters?.airTime === this.getAirTimeForSelectedDay('22:00')) {
        this.$refs.directFilter2200.classList.add('bx-js-active')
      }
    },
    getAirTimeForSelectedDay (time) {
      const airTime = this.selectedFilters.airTime // i.e. "2025-07-18T09:15:00.000Z"
      if (!airTime || !time) return ''

      // Convert the airTime to a timeZone date object
      const timeZonedDate = utcToZonedTime(airTime, this.timeZone)
      const datePart = format(timeZonedDate, 'yyyy-MM-dd') // >> "2025-07-18"

      // combine the date part with the provided time
      const timeZonedDateTimeString = `${datePart} ${time}` // >> "2025-07-18 20:15"
      const parsedTimeZoned = parse(timeZonedDateTimeString, 'yyyy-MM-dd HH:mm', new Date())

      // convert the parsed timeZone date to UTC
      const utcDate = zonedTimeToUtc(parsedTimeZoned, this.timeZone)

      return utcDate.toISOString() // >> i.e. "2025-07-18T18:15:00.000Z"
    },
    // Update the airtime filter and emit the change
    // Only emit if the value is different from the current one
    updateAirtimeFilter (value) {
      if (this.selectedFilters.airTime !== value && this.selectedFilters.airTimeOptions !== value) {
        this.$emit('update:air-time-filter', value)
      }
    },
    // Emit the toggle-filters event to the parent component
    // This will trigger the toggleFilters method in the parent
    toggleFilters () {
      this.$emit('toggle-filters')
    }
  }
}
</script>
